/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {ElGordosRevengeLayers, Layers} from "../view/ElGordosRevengeLayers";
import {ElGordosRevenge} from "../ElGordosRevenge";
import {ElGordosRevengeSound} from "../sound/ElGordosRevengeSound";
import {gsap, TimelineLite, TweenLite} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ElGordosRevengeGameAssets} from "../ElGordosRevengeGameAssets";

export class FreespinIntro extends ContinueScreen {

    private _fsLeftNumber:PIXI.BitmapText;
    private _spineHolder:PIXI.Container;
    private _spine:PIXI.spine.Spine | null;

    constructor() {
        super(ElGordosRevengeLayers.getLayer(Layers.SCREENS)!);

        this._spineHolder = new PIXI.Container();
        this._spineHolder.position.set(360, 360);
        this._container.addChild(this._spineHolder);

        this._fsLeftNumber = new PIXI.BitmapText("", {
            fontName : ElGordosRevengeGameAssets.BITMAP_FONT_FREESPIN_INTRO_NUMBER,
            fontSize : 26,
            tint : 0xffffff
        });
        (<PIXI.Point>this._fsLeftNumber.anchor).set(0.5, 2.1);
        this._container.addChild(this._fsLeftNumber);
    }

    public show(onContinueCallBack:() => void):TimelineLite {
        ElGordosRevenge.xBetController.featureVisible = false;
        ElGordosRevenge.shootingScreen.enabled = false;
        // ElGordosRevenge.multiplier.updateMultiplier(ElGordosRevenge.model.data.multiplierFS, false);
        ElGordosRevenge.background.updateMode(ElGordosRevenge.model.data.nextMode);
        const fsLeft = ElGordosRevenge.model.isRestore ? ElGordosRevenge.model.parsedInitData.freespinsLeft : ElGordosRevenge.model.parsedGameData.freespinsLeft;
        this._fsLeftNumber.text = `${fsLeft}`;
        this._fsLeftNumber.alpha = 1;
        this._fsLeftNumber.position.set(360, ElGordosRevenge.model.data.nextMode === GameMode.FREESPIN_SUPER ? 336 : 310);
        this._fsLeftNumber.alpha = 0;
        this._spine = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset(`${ElGordosRevenge.model.data.nextMode === GameMode.FREESPIN_SUPER ? "sfs" : "fs"}Intro`));
        this._spine.autoUpdate = true;
        this._spine.skeleton.setSkinByName(fsLeft === 1 ? "spin" : "spins");
        this._spineHolder.addChild(this._spine);
        this._spine.state.setAnimation(0, "intro", false);
        ElGordosRevengeSound.switchMusic(
            {name : ElGordosRevengeSound.FREE_SPIN_INTRO, volume : 0},
            {name : ElGordosRevengeSound.FREE_SPIN_INTRO, to : 1, duration : 100},
            {name : "", to : 0, duration : 100}
        );
        ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.FREE_SPIN_INTRO_START});
        return super.show(onContinueCallBack);
    }

    protected getShowAnimations():TimelineLite {
        const tl = new TimelineLite();
        tl.add([
            () => {
                ElGordosRevenge.initialCountUp.remove();
                ElGordosRevenge.bigWinCountUp.remove();
                ElGordosRevenge.waysWon.remove();
            },
            TweenLite.to(this._fsLeftNumber, 0.5, {alpha : 1, delay : 1})
        ]);
        tl.add(() => {
            this._spine!.state.setAnimation(0, "loop", true);
        }, this._spine!.spineData.findAnimation("intro").duration);
        return tl;
    }

    protected close():TimelineLite {
        const tl = super.close();
        tl.add([
            gsap.to(this._fsLeftNumber, {alpha : 0, duration : 0.3})
        ], 0);
        tl.add(() => {
            this._spine!.state.setEmptyAnimations(0);
            this._spineHolder.removeChild(this._spine!);
            this._spine!.destroy();
            this._spine = null;
            ElGordosRevenge.background.updateMode(ElGordosRevenge.model.data.nextMode);
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.FREE_SPIN_START});
            ElGordosRevengeSound.switchMusic({
                name : ElGordosRevenge.model.data.nextMode.includes("SUPER") ?
                    ElGordosRevengeSound.SUPER_FREE_SPIN_MUSIC : ElGordosRevengeSound.FREE_SPIN_MUSIC,
                volume : 1
            });
        }, 0);
        tl.add(ElGordosRevenge.fsMeter.show(ElGordosRevenge.scatters.scatters.length === 4), 0);
        return tl;
    }
}